import React from "react";
import PropTypes from "prop-types";
import { Button, Icon } from "zina-dogi-react";
import DatePicker from "react-datepicker";
import { Formik, Form, Field } from "formik";
import Select from "react-select";
import BarLoader from "react-spinners/BarLoader";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { service as oetService } from "../../oet/redux";
import "./cpo_filter.scss";
import "react-datepicker/dist/react-datepicker.css";

class CpoFilter extends React.Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        custom: PropTypes.object
    };

    static header = props => {
        const { iscollapse, togglecollapse } = props;
        return (
            <nav className="navbar">
                <span className="navbar-brand h4">Basic Information</span>
                <div>
                    <UncontrolledDropdown>
                        <DropdownToggle tag="span" className="btn-icon">
                            <Icon icon="ellipsis-v" />
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={togglecollapse}>
                                {!iscollapse && (
                                    <span>
                                        <Icon icon="minus-square" /> Minimize
                                    </span>
                                )}
                                {iscollapse && (
                                    <span>
                                        <Icon icon="plus-square" /> Maximize
                                    </span>
                                )}
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            </nav>
        );
    };

    constructor(props) {
        super(props);
        this.state = {
            customers: [],
            loading: false,
            loading_run_report: false
        };
    }

    componentWillUpdate() {
        this.getUploaderData();
    }

    render() {
        const { className } = this.props;
        const initValues = {
            number: "",
            customer_team: "",
            date_gte: null,
            date_lte: null,
            creation_date_gte: null,
            creation_date_lte: null,
            circle: "",
            oet_id: "",
            oet_name: "",
            status: null,
            run_status: null,
            oet_status: null,
            run_action: null
        };
        const submit = (values, cmp) => {
            this.handleSubmit(this.props.onSubmit, values, cmp);
        };

        return (
            <div className={["cpo_filters", className].join(" ")}>
                <Formik initialValues={initValues} onSubmit={submit}>
                    {props => {
                        const { values, setFieldValue } = props;
                        return (
                            <Form>
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                                        <div className="form-group">
                                            <label>CPO number</label>
                                            <Field
                                                title="CPO Number"
                                                name="number"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                                        <div className="form-group">
                                            <label>CPO customer</label>
                                            <Field
                                                component={Select}
                                                name="customer_team"
                                                isClearable
                                                options={this.getUploaderData()}
                                                onChange={val => setFieldValue("customer_team", val, false)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                                        <div className="form-group">
                                            <label>CPO Date (start)</label>
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                selected={values.date_gte}
                                                selectsStart
                                                startDate={values.date_gte}
                                                endDate={values.date_lte}
                                                onChange={value => setFieldValue("date_gte", value, false)}
                                                autoComplete="off"
                                            />
                                            <small id="emailHelp" className="form-text text-muted">
                                                DD/MM/YYYY
                                            </small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                                        <div className="form-group">
                                            <label>CPO Date (end)</label>
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                selectsEnd
                                                selected={values.date_lte}
                                                startDate={values.date_gte}
                                                endDate={values.date_lte}
                                                onChange={value => setFieldValue("date_lte", value, false)}
                                                name="date_lte"
                                                autoComplete="off"
                                            />
                                            <small id="emailHelp" className="form-text text-muted">
                                                DD/MM/YYYY
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                                        <div className="form-group">
                                            <label>CPO Receipt Date (start)</label>
                                            <Field
                                                component={DatePicker}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                selected={values.creation_date_gte}
                                                selectsStart
                                                startDate={values.creation_date_gte}
                                                endDate={values.creation_date_lte}
                                                onChange={value => setFieldValue("creation_date_gte", value, false)}
                                                name="creation_date_gte"
                                                autoComplete="off"
                                            />
                                            <small id="emailHelp" className="form-text text-muted">
                                                DD/MM/YYYY
                                            </small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                                        <div className="form-group">
                                            <label>CPO Receipt Date (end)</label>
                                            <Field
                                                component={DatePicker}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                selected={values.creation_date_lte}
                                                selectsEnd
                                                startDate={values.creation_date_gte}
                                                endDate={values.creation_date_lte}
                                                onChange={value => setFieldValue("creation_date_lte", value, false)}
                                                name="creation_date_lte"
                                                autoComplete="off"
                                            />
                                            <small id="emailHelp" className="form-text text-muted">
                                                DD/MM/YYYY
                                            </small>
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                                        <div className="form-group">
                                            <label>Process</label>
                                            <Field
                                                component={Select}
                                                name="type_flow"
                                                value={values.type_flow}
                                                isClearable
                                                options={this.getOptions("type_flow")}
                                                onChange={val => setFieldValue("type_flow", val, false)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                                        <div className="form-group">
                                            <label>OET ID</label>
                                            <Field className="form-control" name="oet_id" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                                        <div className="form-group">
                                            <label>Circle</label>
                                            <Field className="form-control" name="circle" />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                                        <div className="form-group">
                                            <label>CPO Status</label>
                                            <Field
                                                component={Select}
                                                name="status"
                                                isClearable
                                                value={values.status}
                                                options={this.getOptions("status")}
                                                onChange={val => setFieldValue("status", val, false)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                                        <div className="form-group">
                                            <label>Run Action</label>
                                            <Field
                                                component={Select}
                                                name="run_action"
                                                value={values.run_action}
                                                isClearable
                                                options={this.getOptions("run_action")}
                                                onChange={val => setFieldValue("run_action", val, false)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                                        <div className="form-group">
                                            <label>RUN Status</label>
                                            <Field
                                                component={Select}
                                                name="run_status"
                                                value={values.run_status}
                                                isClearable
                                                options={this.getOptions("run_status")}
                                                onChange={val => setFieldValue("run_status", val, false)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row controls">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() =>
                                            this.handleSubmit(oetService.runReport, values, props, "runReport")
                                        }
                                    >
                                        Download RUN Report
                                    </Button>
                                    {this.state.loading_run_report && (
                                        <BarLoader loading={this.state.loading_run_report} />
                                    )}
                                    <span className="flex" />
                                    <Button type="reset" color="danger" icon="sync-alt">
                                        Clear filters
                                    </Button>
                                    <Button type="submit" color="primary" icon="filter">
                                        Filter
                                    </Button>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        );
    }

    getUploaderData = () => {
        const { fields } = this.props;
        if (fields) {
            return fields.fields.customer_team.choices.map(choice => ({
                label: choice.display,
                value: choice.value
            }));
        }
        return [];
    };

    getOptions = field => {
        const { fields } = this.props;
        if (fields) {
            return fields.fields[field].choices.map(choice => ({
                label: choice.display,
                value: choice.value
            }));
        }
    };

    handleSubmit = (submit, obj, { setSubmitting }, type = "submit") => {
        const computeValue = key => (obj[key] ? { [key]: obj[key].value } : { [key]: null });
        if (type === "runReport") {
            this.setState({ loading_run_report: true });
        }
        const data = {
            ...obj,
            ...(type === "runReport" ? { last_state: "true" } : {}),
            ...computeValue("status"),
            ...computeValue("run_action"),
            ...computeValue("type_flow"),
            ...computeValue("run_status"),
            ...computeValue("customer_team")
        };
        submit(data).then(() => {
            if (type === "runReport") {
                this.setState({ loading_run_report: false });
            }
        });
        setSubmitting(false);
    };
}

export default CpoFilter;
